export default __webpack_public_path__ + "static/media/zabinji dp done.ed97438c.png";